import AccountIcon from '@mui/icons-material/AccountCircle'
import ChatBubbleIcon from '@mui/icons-material/ChatBubble'
import CurrencyExchangeOutlinedIcon from '@mui/icons-material/CurrencyExchangeOutlined'
import DashboardIcon from '@mui/icons-material/Dashboard'
import EmailIcon from '@mui/icons-material/Email'
import InsertPageBreakOutlinedIcon from '@mui/icons-material/InsertPageBreakOutlined'
import Language from '@mui/icons-material/Language'
import LinkedInIcon from '@mui/icons-material/LinkedIn'
import LocalAtmIcon from '@mui/icons-material/LocalAtm'
import MailIcon from '@mui/icons-material/Mail'
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined'
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined'
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined'
import PermPhoneMsgIcon from '@mui/icons-material/PermPhoneMsg'
import PinDrop from '@mui/icons-material/PinDrop'
import QuizIcon from '@mui/icons-material/Quiz'
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined'
import SavingsIcon from '@mui/icons-material/Savings'
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined'
import WarningIcon from '@mui/icons-material/Warning'
import XIcon from '@mui/icons-material/X'
import YouTubeIcon from '@mui/icons-material/YouTube'
import { ROUTES_PATH } from './routes'

export const EFFICIENCY_LINK = 'https://residents.nationwideenergypartners.com/resident-resources'
export const OUTAGES_LINK = 'https://residents.nationwideenergypartners.com/current-outages'
export const RATES_LINK = 'https://residents.nationwideenergypartners.com/resources-billing/ohio-compare-your-rates'
export const FAQ_LINK = 'https://residents.nationwideenergypartners.com/faq-1'
export const PAPERLESS_LINK = 'https://invoicecloud.net/payer-terms-conditions'

export const PAY_TOOLS = [
  { title: 'Autopay', Icon: CurrencyExchangeOutlinedIcon, page: 3 },
  { title: 'Paperless Billing', Icon: InsertPageBreakOutlinedIcon, page: 2 },
  { title: 'Pay by Text', Icon: TextsmsOutlinedIcon, page: 11 },
  { title: 'Pay Bill', Icon: PaymentsOutlinedIcon, page: 1 },
  {
    title: 'View Bill',
    Icon: ReceiptOutlinedIcon,
    navigate: ROUTES_PATH.BILLING
  },
  { title: 'Wallet', Icon: PaymentOutlinedIcon, page: 5 },
  { title: 'Scheduled Payments', Icon: LocalAtmIcon, page: 9 }
]

export const LOGIN_ITEMS = [
  {
    title: 'Outages',
    icon: WarningIcon,
    link: OUTAGES_LINK
  },
  {
    title: 'Resources',
    icon: SavingsIcon,
    link: EFFICIENCY_LINK
  },
  {
    title: 'FAQ',
    icon: QuizIcon,
    link: FAQ_LINK
  },
  {
    title: 'Contact Us',
    icon: ChatBubbleIcon,
    link: ROUTES_PATH.CONTACT_US
  }
]

export const SERVICE_ITEMS = [
  {
    title: 'Start Service',
    content:
      'To start new MVU electrical service, please call customer service at 877-818-2637.<br><br> Please have the following information available:',
    list: [
      'Service address.',
      'Social security number & driver\'s license number.',
      'Federal Tax ID# (if business).',
      'Primary phone number.',
      'Date to start service (additional fees apply for same day service, weekends, or holidays).',
      'Mailing address (if different from service address).'
    ],

    subcontent:
      '*Please note. There will be a $15.00 activation fee and a $5.00 per person identity verification charge applied to your account.'
  },
  {
    title: 'Stop service',
    content: 'To discontinue MVU residential or commercial electric service please call customer service at 877-818-2637. Please have the following information available:',
    list: ['Service address.', 'Personal identification information.']
  },
  {
    title: 'Move service',
    content: 'If you are moving within the MVU service territory please call customer service at 877-818-2637 and we\'d be happy to help you transfer your account to your new address.'
  }
]


export const SIDEBAR_ITEMS = [
  { title: 'Dashboard', icon: DashboardIcon, href: ROUTES_PATH.DASHBOARD },
  { title: 'My Account', icon: AccountIcon, href: ROUTES_PATH.ACCOUNT },
  { title: 'Usage', icon: null, href: ROUTES_PATH.USAGE },
  { title: 'Billing', icon: ReceiptLongIcon, href: ROUTES_PATH.BILLING },
  { title: 'Account Preferences', icon: SettingsOutlinedIcon, href: ROUTES_PATH.SETTINGS },
  { title: 'Resident Resources', icon: SavingsIcon, href: EFFICIENCY_LINK },
  { title: 'Contact Us', icon: ChatBubbleIcon, href: ROUTES_PATH.CONTACT },
  { title: 'FAQ', icon: QuizIcon, href: FAQ_LINK }
]

export const AUTH_TOPBAR_ITEMS = [
  { title: 'Services', href: ROUTES_PATH.SERVICES },
  { title: 'Efficiency', href: ROUTES_PATH.EFFICIENCY },
  { title: 'Contact Us', href: ROUTES_PATH.CONTACT_US },
  { title: 'Frequently Ask Questions', href: ROUTES_PATH.FAQS }
]

export const TOPBAR_ITEMS = [
  { title: 'Usage', href: ROUTES_PATH.USAGE },
  { title: 'Billing', href: ROUTES_PATH.BILLING },
  { title: 'Resident Resources', href: EFFICIENCY_LINK },
  { title: 'Efficiency', href: ROUTES_PATH.EFFICIENCY },
  { title: 'Contact Us', href: ROUTES_PATH.CONTACT },
  { title: 'Account', href: ROUTES_PATH.ACCOUNT },
  { title: 'Account Preferences', href: ROUTES_PATH.SETTINGS },
  { title: 'Dashboard', href: ROUTES_PATH.PORTAL_DASHBOARD },
  { title: 'FAQ', href: FAQ_LINK }
]

export const MESSAGES = {
  VERIFICATION_CODE_CHECK:
    'A verification code has been sent to your email. Please check your inbox and enter the code below.',
  VERIFICATION_RESENT:
    'A new verification code has been resent. Please allow a few minutes for its delivery. Kindly check your spam folder as well.',
  ACCOUNT_VERIFIED:
    'Your account has been successfully verified. Please proceed to create a password for registration.',
  REQUIRED_NAME_ERROR: 'Please provide your name in the required field.',
  REQUIRED_EMAIL_ERROR:
    'Please enter a valid email address in the required field.',
  REQUIRED_TELEPHONE_ERROR:
    'Please provide a valid telephone number in the required field.',
  REQUIRED_ACCOUNT_NUMBER:
    'Please enter a valid account number in the required field.',
  REQUIRED_SERVICE_ADDRESS:
    'Please enter a valid service address in the required field.',
  SELECT_ONE_ERROR: 'Please select a topic before proceeding.',
  REQUIRED_SUBJECT_ERROR: 'Please enter a subject in the required field.',
  CONTACT_CUSTOMER_ERROR:
    'If this issue persists, please get in touch with our customer service team.',
  OUTAGE_RETRIEVE_ERROR: 'An error occurred while retrieving outage data: ',
  SOMETHING_WRONG_ERROR: 'Oops, something went wrong: ',
  PREFERENCES_UPDATED_SUCCESS:
    'Your preferences have been successfully updated.',
  PREFERENCES_WARN: 'Note: Standard message and data rates may apply.',
  PASSWORD_UPDATED_SUCCESS:
    'Your password has been changed successfully. Please log in using your new password.',
  PASSWORD_MATCH_ERROR: 'New Password and Confirm New Password do not match.',
  ZIP_CODE_ERROR: 'Please provide a valid zip code.',
  STREET_NAME_ERROR: 'Please enter a valid street name.',
  DATE_STOP_SERVICE_ERROR:
    'Please specify the date you would like to stop your service from.',
  WRONG_ERROR: 'Oops, an unexpected error occurred.',
  ENTER_DETAIL_ERROR:
    'Please provide details of your safety concern in the comments section.',
  SERVICE_REQUEST_SUCCESS:
    'Your service request has been successfully submitted.',
  RETRIEVE_ERROR:
    'We are currently experiencing technical difficulties and unable to retrieve your information. Please try again later.',
  IC_RETRIEVE_ERROR: 'Payments are temporarily unavailable.',
  ACCOUNT_RETRIEVE_ERROR:
    'An error occurred while retrieving your account information. Please try again later.',
  FORM_SUBMIT_ERROR:
    'An error occurred while submitting the form. Please try again.',
  FORM_SUBMIT_SUCCESS:
    'Your request has been submitted successfully. You will receive a response within 24 hours. You will now be redirected to the home page.',
  BILL_PDF_ERROR:
    'We are currently unable to retrieve the PDF version of your bill. Please try again later. You can view a summary of your bill and bill history on the billing tab.',
  ACCOUNT_UPDATED_SUCCESS:
    'Your account details has been successfully updated.',
  ACCOUNT_UPDATED_ERROR:
    'An error occurred while updating your account details. Please try again later.',
  UPDATE_LIMIT_EXCEEDED:
    'Please note that you can only update your mailing address once within a 24-hour period. Kindly try again later.',
  USER_CONFIRM_WARNING:
    'Please confirm your email address by entering the confirmation code sent to your inbox.',
  OUTAGES_ERROR:
    'An error occurred while retrieving your outage information. Please try again later.',
  OUTAGES_API_ERROR:
    'An error occurred while fetching outage information. Please try again later.',
  PAYMENT_INFO:
    'If you have made a payment, it may take a few minutes for the balance to reflect the payment.',
  BILL_ERROR:
    'We are currently unable to retrieve the PDF version of your bill. Please try again later. You can view a summary of your bill and bill history on the billing tab.',
  ADMIN_ACCESS_ERROR: 'Administrators are not permitted to do this action.',
  VERIFY_PAY_BILL_ERROR:
    'An error occurred while retrieving your account information. Please double-check your details and try again.',
  EMAIL_UPDATED_SUCCESS:
    'Your email has been changed successfully. Please log in using your new email.',
  IC_PAPERLESS_INFO:
    'If you’ve updated your preferences, please allow up to 10 minutes for it to reflect in your account'
}

export const MONTHS = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec'
]

export const USAGE_MENU_ITEMS = [
  { title: 'Calendar', label: 'Monthly View', icon: 'CalendarIcon' },
  { title: 'CalendarOne', label: 'Daily View', icon: 'Calendar1Icon' },
  { title: 'Clock', label: 'Hourly View', icon: 'ClockIcon' }
]


export const BILLING_QUESTIONS = [
  {
    title: 'When will I receive my bill?',
    content:
      'You will receive your bill on a monthly basis.'
  },
  {
    title: 'When is my bill due?',
    content:
      'Your payment due date is clearly indicated on both the top and bottom of the bill you have received in the mail or via email.'
  },
  {
    title: 'How do I sign up for notifications?',
    content:
      'Notification preferences can be managed in a few places within the portal. Paperless Billing notifications are set in the Account Preferences menu, while payment-related notifications (such as Autopay, Paperless Billing, and Pay by Text) can be enabled through the Quick Links located above the portal section. Simply click on the relevant Quick Link to update your notification preferences.'
  },
  {
    title: 'How do I sign up for paperless billing (ebills)?',
    content: 'You can sign up for paperless billing through the Account Preferences menu in the portal, or by clicking the paperless Billing Quick Link located above the portal section. Once enrolled, you’ll receive electronic bills instead of paper statements. If you need further assistance, you can call us at: 877-818-2637.'
  },
  {
    title: 'What do I do if I have a question about my bill?',
    content: 'You can either contact us through the Contact Us form (see below), or send us an email at ResidentSupport@NationwideEnergyPartners.com, or you can call us at: 877-818-2637.'
  }
]


export const CONTACT_INFORMATION = [
  {
    image: Language,
    title: 'Website',
    description: '<a target="_blank" rel="noopener noreferrer" href="https://www.nationwideenergypartners.com/">Visit Website</a>'
  },
  {
    image: EmailIcon,
    title: 'Email',
    description: '<a href="mailto:ResidentSupport@NationwideEnergyPartners.com">Send an Email</a>'
  },
  {
    image: PinDrop,
    title: 'Address',
    description: '230 West Street'
  }
]

export const CONTACT_SOCIAL_ITEMS = [
  {
    icon: LinkedInIcon,
    title: '/nationwide-energy-partners',
    link: 'https://www.linkedin.com/company/nationwide-energy-partners/'
  },
  {
    icon: null,
    title: '@nationwide_energy',
    link: 'https://twitter.com/NationwideEner1'
  },
  {
    icon: YouTubeIcon,
    title: '@nationwide_energy',
    link: 'https://www.youtube.com/@NationwideEnergyPartners'
  },
  {
    icon: PermPhoneMsgIcon,
    title: '877-818-2637',
    link: 'tel:877-818-2637'
  },
  {
    icon: EmailIcon,
    title: 'ResidentSupport@NationwideEnergyPartners.com',
    link: 'mailto:ResidentSupport@NationwideEnergyPartners.com'
  }
]

export const FOOTER_SOCIAL_LINKS = [
  {
    icon: LinkedInIcon,
    link: 'https://www.linkedin.com/company/nationwide-energy-partners/'
  },
  {
    icon: XIcon,
    link: 'https://twitter.com/NationwideEner1'
  },
  {
    icon: YouTubeIcon,
    link: 'https://www.youtube.com/@NationwideEnergyPartners'
  }
]


export const TOPIC_ITEMS = ['Outage', 'Billing Inquiry', 'Email Registration', 'Payment Inquiry', 'Move Inquiry', 'Other']


export const EFFICIENCY_DATA = {
  title: 'Efficiency',
  subtitle: '',
  type: 'items',
  itemBackground: true,
  items: [
    {
      title: 'AC or HP Tune-up Rebate',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Business Rebate Application',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Commercial Energy Audit...',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    },
    {
      title: 'Energy Efficiency Program...',
      link: 'https://www.moval.org/mvu/efficiency-progs.html'
    }
  ]
}

export const ServicesFooterButtonData = [
  {
    title: 'Contact Us',
    desc: 'Need additional assistance? Contact us, we are here to help you.',
    link: ROUTES_PATH.CONTACT_US,
    linkTitle: 'Go to Contact Us',
    icon: MailIcon
  }
]

export const ServiceFormRequestType = {
  startService: 'START',
  stopService: 'STOP',
  meterReadVerification: 'MRV',
  safety: 'SAFETY'
}

export const FAQS_ITEMS = [
  {
    ul: [
      {
        title: 'Will I pay more with NEP?',
        content: 'No. NEP is contractually obligated to always match or charge less than local utilities’ current rate for residential electric usage. In other words, the rate applied to your usage will never be higher than that of the local utility. NEP has a team that continuously monitors local utility rates and we contract with a third-party accounting firm to conduct a yearly audit to ensure rate accuracy.'
      },
      {
        title: 'How does submetering work?',
        content: 'NEP deploys revenue-grade smart meters from industry-leading manufacturers, such as Itron, Elster, and Badger. Each meter is verified at the factory to meet ANSI, IEC, and FCC standards ensuring the device is reliable and accurate. NEP obtains a final read from your meter daily and, in most cases, we contact your meter every 15 minutes for fresh data. Your meter measures the amount of electricity and/or water used in your residence only. NEP exclusively deploys 100%, two-way, smart meters that actively communicate with NEP to provide proactive information on items such as outages or voltage changes.<br><br>Note: A missing reading does not indicate that your meter is inaccurate or not functioning properly. Smart meters use secure, wireless technology to transmit data and, just like your cell phone, sometimes the wireless network may be unavailable. The benefit of using 100% smart meters is they will store the usage data and transmit it at the next opportunity when the wireless network is available. This means your meter will continue to measure and display correct advancement as usage occurs even if the network is unavailable.'
      },
      {
        title: 'How do electric meters and water meters work?',
        content: "Explore our new <a class='accordion-link' href='https://residents.nationwideenergypartners.com/how-it-works'>How It Works</a> page, where you can download great informational articles that share how the different types of meters work, how we ensure their accuracy, and how they impact your monthly bill."
      },
      {
        title: 'What will my bill look like and when will I receive it?',
        content: 'At the request of the property owner, NEP delivers a unified bill to each resident in the community.  A unified bill conveniently combines several services into one single bill.  Your unified bill may include usage and charges related to electric, water, and common area usage (known as “community charges”).  These charges are considered the utilities portion of your rent.<br><br>You will receive a bill each month.  The date you receive your bill will be based on your community’s billing cycle.  You may elect to receive your billing statement via email through our paperless billing option or have it delivered via regular mail through the U.S. Postal Service.'
      },
      {
        title: 'What is common area usage?',
        content: 'To provide greater transparency of usage, your property may elect to have NEP bill for the common area usage at your property.  Common area usage (CAU) is the electric and/or water cost of the shared, or common, areas of your community.  Common areas are those that no single resident is responsible for and may include facilities and amenities such as pools, streetlights, workout facilities, irrigation systems, etc.  This cost is shared equally among all community residents and is listed separately on your monthly bill statement as “community charges.”'
      },
      {
        title: 'Do I need to do anything to set up or cancel my account?',
        content: 'No.  This is one of the many benefits NEP provides.  Residents will have their account automatically set up when they move in and automatically deactivated when they move out.'
      },
      {
        title: 'Will NEP reimburse me for food spoiled due to a power outage?',
        content: 'Your power is supplied by your local utility. NEP is not responsible for damages or food spoilage caused by local utility outages due to such factors as extreme weather. '
      },
      {
        title: 'Who do I call to report power outages?',
        content: 'Please report power outages to NEP by calling (877) 818-2637.'
      }
    ]
  }
]
